import React from "react";
import { Helmet } from "react-helmet";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar.jsx";
import GeneralConst from "../../consts/GeneralConst.js";
import GeneralStrings from "../../strings/GeneralStrings.json";
import Footer from "../../components/Footer/Footer";
import "./Homepage.scss";
import { Link } from "@mui/material";
import RoutesConst from "../../consts/RoutesConst.js";

const TITLE = `Home | ${GeneralConst.SITE_NAME}`;

const Homepage = () => {
  return (
    <div className="homepage">
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <HomepageNavbar transparentNavbar={false} />
      <section className="masthead">
        <div className="container">
          <div className="heading text-uppercase">
            {GeneralStrings.MAKE_A_WAVE}
          </div>
          <div className="subheading">
            {GeneralStrings.PRIVATE_SWIM_LESSONS}
          </div>
          <Link className="cta-link" href={RoutesConst.SERVICES}>
            {GeneralStrings.LETS_GET_STARTED}
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Homepage;
